import Layout from './layout.model'

let storeContent = utils.generateStore({
   Layout,
   FormModel: {},
   selectedModel: '',
   initials: 'JD'
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async generateInitials(ctx,names){
         let split = names.split(' '), initials  = ''

         if(split.length >= 2){
            initials = split[0].charAt(0) + split[1].charAt(0)
            initials = initials.toUpperCase()
            ctx.commit('initials',initials)
         }
      },
      async logOut(ctx,router){
         await $session.remove('user')
         await $session.remove('role')
         await $session.remove('token')
         router.push({name: 'LogIn'})
      },
      async clickAction (ctx,model){
         ctx.commit('selectedModel',model)
         if(model === 'password'){

         }else if(model === 'project'){

         }else{

         }
      },
   }
}